/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import { Spacing } from '../../../styles/variables';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledPricingPlan = styled.div`
  text-align: center;
  padding-top: ${Spacing.Small};
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledPricingPlan/index.js